// extracted by mini-css-extract-plugin
export var checkbox = "_71-0";
export var circle = "_71-3";
export var horizontalContainer = "_71-7";
export var sm = "_71-5";
export var switch0 = "_71-2";
export var switchDisabled = "_71-8";
export var switchEnabled = "_71-1";
export var textSwitchContainer = "_71-9";
export var textSwitchOption = "_71-a";
export var textSwitchOptionSelected = "_71-b";
export var verticalContainer = "_71-6";
export var xs = "_71-4";